import {
  LoadingContainer,
  LegacyPage,
  Modal,
  Model,
  Panels,
  Bar,
  Input,
  NumericInput,
  DateInput,
  Select,
  Textarea,
  Breadcrumb,
} from 'peach/components'
import { getName } from 'peach/helpers'
import { useParams } from 'peach/router'

import {
  useInternalDrawPurchaseGetOne,
  useInternalDrawPurchaseUpdate,
} from 'core/types'

const DrawPurchase = () => {
  const { companyId, personId, loanId, drawId, purchaseId } = useParams<{
    companyId?: string
    personId?: string
    loanId?: string
    drawId?: string
    purchaseId?: string
  }>()

  const {
    data: purchase,
    isLoading,
    error,
  } = useInternalDrawPurchaseGetOne({
    companyId,
    personId,
    loanId,
    drawId,
    purchaseId,
    options: {
      enabled: !!(companyId && personId && loanId && drawId && purchaseId),
    },
  })

  const { mutateAsync: updatePurchase, isPending: isUpdatingPurchase } =
    useInternalDrawPurchaseUpdate({
      companyId,
      personId,
      loanId,
      drawId,
      purchaseId,
    })

  const sendEditPurchase = async (formData) => {
    try {
      await updatePurchase(formData)
    } catch (err) {
      console.error('Error updating purchase:', err)
    }
  }

  return (
    <Panels header={<Bar title='Purchase' />}>
      <Breadcrumb title={getName(purchase)} />
      <Modal
        initialValue={purchase}
        onSubmit={sendEditPurchase}
        title='Edit Purchase'
      >
        <NumericInput formKey='amount' />
        <DateInput formKey='purchaseDate' required />
        <Input formKey='externalId' />
        <Select formKey='type' options={['regular', 'refund', 'cashBack']} />
        <Select formKey='status' options={['settled', 'pending', 'canceled']} />
        <Textarea.Json formkey='metadata' />
      </Modal>
      <LoadingContainer
        error={error}
        isLoading={isLoading || isUpdatingPurchase}
      >
        <LegacyPage.Full>
          <Model.Item json={purchase} />
        </LegacyPage.Full>
      </LoadingContainer>
    </Panels>
  )
}

export default DrawPurchase
